/**
 * Handle display and validation of AP Registration
 */
const $inject = [
  "RegistrationService",
  "$timeout",
  "CommonData",
];

class RegistrationController {

  constructor(
    RegistrationService,
    $timeout,
    CommonData
  ) {
    this.debug = false;

    this.pharmacist = {
      accountHolder: {},
    };
    this.registrationService = RegistrationService;

    this.registerPA = {
      registerSuccess: false,
      error: false,
      message: "",
    };

    this.validationMessage = [];

    this.timeout = $timeout;
    this.submittedSendResetEmailPassword = {
      sent: false,
      error: false,
      message: "",
    };
    this.submittedResetPassword = {
      error: false,
      message: "",
      successUrl: "/app",
    };

    if (window.globalData && window.globalData.error) {
      this.globalError = true;
      this.globalMessage = window.globalData.message;
    }

    this.titles = CommonData.TITLES;
  }

  /**
   * Attempt to create the user, on submit
   */
  register(form) {
    this.submitted = true;
    this.registerForm = form;
    this.registerForm.validationMessage = null;

    var self = this;

    var handleSuccess = function (response) {
      if (!response.data.error) {
        self.registerPA.registerSuccess = true;
        self.registerPA.error = false;
        self.registerPA.message = response.data.message;
      }
      else {
        handleError(response);
      }
    };

    var handleError = function (response) {
      self.loading = false;
      self.registerPA.registerSuccess = false;
      self.registerPA.error = true;
      self.validationMessage = response.data.message;
      self.registerForm.validationMessage = response.data.message;

      for (var element in response.data.message) {
        if (self.registerForm[element]) {
          self.registerForm[element].$setValidity("server", false);
        }
      }
      self.registerPA.message = response.data.message;
    };

    if (form.$valid) {
      this.loading = true;
      this.registrationService.createPharmacist(this.pharmacist, handleSuccess, handleError);
    }
  }

  /**
   * Reset the user's password
   */
  resetPassword() {
    if (window.globalData && window.globalData.hash) {

      var self = this;

      var handleSuccess = function (response) {
        if (!response.data.error) {
          window.location.href = self.submittedResetPassword.successUrl;
        }
        else {
          handleError(response);
        }
      };

      var handleError = function (response) {
        //TODO define behaviour
        self.submittedResetPassword.error = true;
        self.submittedResetPassword.message = "An error occurred.";
      };

      this.registrationService.resetPassword(window.globalData.hash, this.password, handleSuccess, handleError);
    }
  }

}

RegistrationController.$inject = $inject;

export default RegistrationController;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/features/account/controllers/registration.controller.js
 **/